( function () {
	'use strict';

	function templateDigitalSignatureCtrl ( fileService, logger, uiModal ) {
		var self = this;

		function templateDigitalSignatureModel () {
			return self.parentScope.vm;
		}

		function openDigitalSignatureModal () {
			uiModal.open( {
				'templateUrl'  : '/templates/templates-new/template-digital-signature/digital-signature-modal/template-modal.html',
				'controller'   : 'templateDigitalSignatureModalCtrl',
				'controllerAs' : 'vm',
				'keyboard'     : false,
				'resolve'      : {
					'templateDigitalSignatureModel' : templateDigitalSignatureModel
				}
			} );
		}

		self.openDigitalSignatureModal     = openDigitalSignatureModal;
		self.templateDigitalSignatureModel = templateDigitalSignatureModel;
	}

	templateDigitalSignatureCtrl.$inject = [ 'fileService', 'logger', '$modal' ];

	angular
		.module( 'app.templates' )
		.controller( 'templateDigitalSignatureCtrl', templateDigitalSignatureCtrl );
} )();
